export interface Seller {
  name: string;
  score: number;
  qcRating: number;
  orders: number;
  category: string;
  badge: string;
}

export const sellers: Seller[] = [
  { name: 'TopShoe Supply', score: 9.7, qcRating: 9.5, orders: 12500, category: 'Shoes', badge: 'Verified' },
  { name: 'UrbanWear Direct', score: 9.4, qcRating: 9.2, orders: 8900, category: 'Clothing', badge: 'Top Rated' },
  { name: 'BagEmporium', score: 9.6, qcRating: 9.6, orders: 6700, category: 'Bags', badge: 'Verified' },
  { name: 'AccessoryHub', score: 9.3, qcRating: 9.1, orders: 5400, category: 'Accessories', badge: 'Fast Ship' },
  { name: 'JerseyKing', score: 9.5, qcRating: 9.4, orders: 7800, category: 'Jersey', badge: 'Top Rated' },
  { name: 'LuxuryGoods Pro', score: 9.8, qcRating: 9.7, orders: 3200, category: 'Luxury', badge: 'Premium' },
];